<template>
  <div
    :class="focusBool ? 'is-active' : ''"
    class="rt-daterangepicker"
  >
    <!-- =={{startDate}} -->
    <rt-date-picker
      :type="type"
      :placeholder="computedStartPlaceholder"
      :value="startDate"
      :disabled="computedDisabled"
      :format="format"
      :picker-options="startPickerOptions"
      :clear-icon-right="clearIconRight"
      class="rt-date-picker"
      @focus="focusInput"
      @blur="focusInput"
      @input="v => DateChange(v, 'startDate')"
    />
    <span>-</span>
    <!-- =={{endDate}} -->
    <rt-date-picker
      ref="datePicker"
      :type="type"
      :placeholder="computedEndPlaceholder"
      :value="endDate"
      :disabled="endDisabled || computedDisabled"
      :format="format"
      :picker-options="endPickerOptions"
      :clear-icon-right="clearIconRight"
      @focus="endStartFocus"
      @blur="focusInput"
      @input="v => DateChange(v, 'endDate')"
    />
  </div>
</template>

<script>
import moment from 'moment';
import rtDatePicker from './rtDatePicker';
import Placeholder from './placeholder.js';
export default {
  name: 'RtDateRangePicker',
  components: {
    rtDatePicker
  },
  mixins: [Placeholder],
  props: {
    value: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'date'
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    }, // 必填
    format: {
      type: String,
      default: 'yyyy-MM-dd'
    },
    // 自定义清空按钮位置
    clearIconRight: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      focusBool: false,
      startDate: this.value && this.value[0],
      endDate: this.value && this.value[1],
      // Start Picker Options
      startPickerOptions: {
        disabledDate: time => {
          if (this.endDate) {
            // 只能选择结束日期以前的时间
            return moment(time).isAfter(
              moment(this.endDate)
                .add(-1, 'day')
                .endOf('day')
            );
          }
        }
      },
      // End Picker Options
      endPickerOptions: {
        disabledDate: time => {
          if (this.startDate) {
            // 只能选择开始日期以后的时间
            return moment(time).isBefore(
              moment(this.startDate)
                .add(1, 'day')
                .startOf('day')
            );
          }
        }
      }
    };
  },
  inject: {
    elForm: {
      default: ''
    }
  },
  computed: {
    computedDisabled () {
      return this.disabled || (this.elForm || {}).disabled;
    },
    endDisabled () {
      return this.value && !this.value[0];
    }
  },
  watch: {
    value (val) {
      if (val) {
        this.startDate = val[0];
        this.endDate = val[1];
      }
    }
  },
  methods: {
    focusInput () {
      this.focusBool = !this.focusBool;
    },
    DateChange (val, type) {
      let _startDate = type === 'startDate' ? val : this.startDate;
      let _endDate = type === 'endDate' ? val : this.endDate;

      if (!_startDate) {
        _endDate = '';
      } else if (_startDate && _endDate) {
        const _startTime = new Date(_startDate).getTime();
        const _endTime = new Date(_endDate).getTime();

        if (_startTime >= _endTime) {
          rt.showErrorToast(this.$tx('结束日期不能早于开始日期！', 'xpc.datepicker.endDateCannotEarlierStartDate'));
          if (type === 'startDate') {
            _startDate = ''
          } else {
            _endDate = ''
          }
        }
      }

      const newValue = [_startDate, _endDate];

      this.$emit('input', newValue);
      this.$emit('dateupdate', newValue);
    },

    endStartFocus () {
      this.focusInput();
      if (!this.startDate) {
        rt.showErrorToast(this.$tx('请先选择开始日期！', 'xpc.datepicker.pleaseSelectStartDate'));
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtDateRangePicker.vue?45e34b54